import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { AppContext } from '../../context/AppContext';
import BakeasyHeaderLabel from '../../components/lables/BakeasyHeaderLabel';
import BakeasyTable, { HeadCell } from '../../components/tables/BakeasyTable';
import { t } from 'i18next';
import BakeasyEmptyMsg from '../../components/common/BakeasyEmptyMsg';
import { useNavigate } from 'react-router-dom';
import BakeasyPaper from '../../components/common/BakesasyPaper';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  fetchProductionReport,
  productionReportState
} from '../../redux_store/slices/productionReportSlice';
import { UNAUTHORIZED } from '../../constants/Constants';
import { authActions } from '../../redux_store/slices/authSlice';
import { formatDateTime } from '../../utils/DateUtils';
import { BakeasyChip, BakeasyChipEdit } from '../../components/common/BakeasyChip';

export const ProductionReport: FC = (): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const tableRef = React.useRef<any>();
  let myContext = React.useContext(AppContext);

  const [productionReportHistory, setProductionReportHistory] = useState<any[]>([]);
  const [count, setCount] = useState<number>(0);

  let { error, value, rowsPerPage, pageNo, filter } = useAppSelector(productionReportState);

  const tableHeaders: HeadCell[] = [
    { id: 'productionId', label: 'PRODUCTION_ID', width: '190px' },
    { id: 'orderId', label: 'ORDER_ID' },
    { id: 'productionDate', label: 'PRODUCTION_DATE', sort: true, width: '190px' },
    { id: 'isReceipeBuilder', label: 'RECIPE_BUILDER', sort: true, align: 'center' },
    { id: 'actions', label: 'ACTIONS', align: 'center', width: '100px' }
  ];

  const refreshPageData = async (newPage: number, search?: string, filter?: {} | undefined) => {
    let payload: any = {
      limit: rowsPerPage,
      page: newPage + 1,
      sortBy: 'productionDate',
      sortDirection: -1
    };

    if (filter != undefined && filter !== '') {
      payload = { ...payload, ...filter };
    }

    payload = { ...payload, page: newPage + 1 };

    if (search === undefined || search === '') {
      delete payload['search'];
    }

    if (search !== undefined && search !== '') {
      payload = { ...payload, search };
    }

    if (payload['sortBy'] === 'createdDate') {
      payload['sortBy'] = 'productionDate';
    }

    await dispatch(fetchProductionReport(payload));
  };

  useEffect(() => {
    if (error === UNAUTHORIZED) {
      dispatch(authActions.logout());
    }
  }, [error]);

  useEffect(() => {
    if (value?.totalCount === -1) {
      refreshPageData(pageNo);
    } else {
      const filteredData: any = value?.data?.map((productionReport: any) => {
        return {
          id: productionReport?._id,
          productionId: productionReport?.productionId,
          onProductionIdClick: () => {
            navigate('/productionReportDetails', {
              state: {
                orderIds: productionReport?.orderIds,
                productionId: productionReport?.productionId
              }
            });
          },
          productionDate: productionReport?.productionDate
            ? formatDateTime(productionReport?.productionDate)
            : '',
          //orderId: productionReport?.orderIds.slice(0, 2).join(', '),
          orderId: productionReport?.orderIds?.map((item: any) => item?.orderId + ', '),
          isReceipeBuilder: productionReport?.recipeBuilder ? (
            <BakeasyChip label="Yes" />
          ) : (
            <BakeasyChip
              label="No"
              tooltipTitle="To subscribe to Recipe Builder, please contact Bakeasy"
            />
          ),
          actions: [
            <BakeasyChipEdit
              key={productionReport?._id}
              onClick={async (event: any) => {
                event.stopPropagation();
                openProductionOrderDialog(true, productionReport?.orderIds);
              }}
            />
          ]
        };
      });

      setProductionReportHistory(filteredData);
      setCount(value?.totalCount);
    }
  }, [value]);

  function openProductionOrderDialog(isEdit: any, data: any) {
    return myContext.setDialog({
      open: true,
      title: 'SELECT_ORDERS_TO_CANCEL',
      dialogContent: {
        pageName: 'ProductionCancelOrder',
        params: { isEdit, data },
        onBack: async () => {
          await refreshPageData(pageNo - 1);
        }
      }
    });
  }

  function productionReportHistoryUI() {
    return (
      <Grid>
        <BakeasyPaper>
          <BakeasyHeaderLabel message={t('PRODUCTION_REPORT_HISTORY')} />

          <>
            <Grid mt={1}>
              {productionReportHistory?.length > 0 ? (
                <BakeasyTable
                  ref={tableRef}
                  headers={tableHeaders}
                  tableData={productionReportHistory}
                  count={count}
                  filter={filter}
                  pageNo={pageNo - 1}
                  refreshPageData={refreshPageData}
                />
              ) : (
                <BakeasyEmptyMsg message={t('NO_DATA_FOUND')} />
              )}
            </Grid>

            <Grid item sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Grid container sx={{ alignItems: 'end', justifyContent: 'end' }}></Grid>
            </Grid>
          </>
        </BakeasyPaper>
      </Grid>
    );
  }

  return productionReportHistoryUI();
};
